// ═══════════════════════════════════════════════════════════════════════════
// SICUREZZA DI CANTIERE — lettura e scrittura (ottobre 2026)
// ═══════════════════════════════════════════════════════════════════════════
// Un documento per commessa: sicurezzaCantiere/{projectId}. Regole in sicurezzaCantiere.js.
// Lo storico cresce soltanto (lo impongono anche le Regole Firestore): ogni risposta,
// adempimento, cambio di responsabile e chiusura dell'avviso resta registrato.
// Notifica ed email al responsabile le manda il server (functions: avvisoResponsabileSicurezza)
// ogni volta che il responsabile viene assegnato o cambia.
// ═══════════════════════════════════════════════════════════════════════════
import { doc, setDoc, updateDoc, serverTimestamp, arrayUnion, deleteField } from "firebase/firestore";
import { db } from "../firebase";
import { configIniziale } from "./sicurezzaCantiere";

const ora = () => new Date().toISOString();
const riga = (utente, azione, dettaglio = "") => ({ il: ora(), uid: utente?.uid || "", chi: utente?.displayName || utente?.email || "", azione, dettaglio });

/** Attiva la sicurezza di cantiere su una commessa (alla creazione o dopo). */
export async function attivaSicurezzaCantiere({ projectId, project, organizationId, responsabile, utente }) {
  await setDoc(doc(db, "sicurezzaCantiere", projectId), {
    projectId, organizationId,
    projectName: project?.name || "", codiceCommessa: project?.codiceCommessa || "",
    responsabileUid: responsabile?.uid || "", responsabileNome: responsabile?.nome || "",
    config: configIniziale(project), configConfermata: false,
    stati: {}, avviso: null,
    storico: [riga(utente, "Sicurezza di cantiere attivata", responsabile?.nome ? `Responsabile: ${responsabile.nome}` : "Responsabile da indicare")],
    createdAt: serverTimestamp(), updatedAt: serverTimestamp(),
  });
  await updateDoc(doc(db, "projects", projectId), { cantiere: true, updatedAt: serverTimestamp() });
}

export async function salvaConfig(projectId, config, utente, descrizione) {
  await updateDoc(doc(db, "sicurezzaCantiere", projectId), {
    config, configConfermata: true,
    storico: arrayUnion(riga(utente, "Domande sul cantiere aggiornate", descrizione)), updatedAt: serverTimestamp(),
  });
}

export async function impostaVoce(projectId, voce, stato, nota, utente) {
  const valore = stato === "daFare" ? deleteField() : { stato, nota: nota || "", il: ora(), uid: utente?.uid || "", chi: utente?.displayName || utente?.email || "" };
  const etichetta = { fatto: "Completato", nonApplicabile: "Non applicabile", daFare: "Riaperto" }[stato];
  await updateDoc(doc(db, "sicurezzaCantiere", projectId), {
    ["stati." + voce.id]: valore,
    storico: arrayUnion(riga(utente, `${etichetta}: ${voce.titolo}`, nota || "")), updatedAt: serverTimestamp(),
  });
}

export async function cambiaResponsabile(projectId, responsabile, utente) {
  await updateDoc(doc(db, "sicurezzaCantiere", projectId), {
    responsabileUid: responsabile?.uid || "", responsabileNome: responsabile?.nome || "",
    storico: arrayUnion(riga(utente, "Addetto alla sicurezza cambiato", responsabile?.nome || "nessuno")), updatedAt: serverTimestamp(),
  });
}

/** Chiude l'avviso rosso: motivo obbligatorio, resta nello storico. */
export async function chiudiAvviso(projectId, avviso, motivo, utente) {
  await updateDoc(doc(db, "sicurezzaCantiere", projectId), {
    avviso: { chiusoIl: ora(), chiusoDaUid: utente?.uid || "", chiusoDaNome: utente?.displayName || utente?.email || "", motivo, vociAperte: avviso.idAperte || [], eraDaConfigurare: !!avviso.daConfigurare },
    storico: arrayUnion(riga(utente, "Avviso di sicurezza chiuso", motivo)), updatedAt: serverTimestamp(),
  });
}
